/**
 * The Type class defines a supported data type, like strings,
 * numeric values, decimals, dates, currencies and so on. It is NOT
 * part of the XML representation of the generated Excel document.
 *
 * This class is marked as abstract therefore only its sub-classes
 * should be used.
 *
 * @param {Object} oConfig Type specific configuration
 * @constructor
 * @abstract
 */
function Type(oConfig) {
	this.styleId = null;
	this.alignment = oConfig && oConfig.textAlign ? oConfig.textAlign : null;
}

/**
 * Creates the type specific configuration that is used to register
 * its corresponding style in the Styles class.
 *
 * All subclass implementations have to call the superclass method to
 * ensure that alignment information will not be lost.
 *
 * @param {Object} oData Line item that will be used to evaluate the cell content
 * @returns {Object} Configuration object that may contain alignment information
 * @protected
 */
Type.prototype._createConfiguration = function(oData) {
	return this.alignment ? { align: {	horizontal: this.alignment }} : {};
};

/**
 * Returns the assigned ID of the Type specific Style that is
 * registered in the Styles class.
 *
 * @param {Object} [oData] Business object that contains the actual data
 * @param {string|number} [vValue] Explicit cell value that might be used for semantic formatting
 * @returns {number} ID of the registered Style
 */
Type.prototype.getStyleId = function(oData, vValue) {
	if (this.styleId === null) {
		this.styleId = this.styles.addStyle(this._createConfiguration(oData));
	}

	return this.styleId;
};

/**
 * Registers the Style configuration of this Type in the given Styles
 * class.
 *
 * @param {Styles} oStyles Styles instance where the Type specific styling will be registered
 */
Type.prototype.registerAt = function(oStyles) {
	this.styles = oStyles;
};

/**
 * Returns the data value of the business object that is bound by
 * this type.
 *
 * @param {string} sProperty Name of the property that shall be accessed.
 * @param {Object} oData Business object that contains the data.
 *
 * @returns {string|number|boolean|null} The value of the given property after type specific processing.
 */
Type.prototype.getValue = function(sProperty, oData) {
	return oData[sProperty];
};

module.exports = Type;